// extracted by mini-css-extract-plugin
export default {"tag":"InputHashTagRow_tag__wI9Qi"};